import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const TICKER_COLORS = {
  TSLA: "#a78bfa",
  MSFT: "#f87171",
  IBM: "#4ade80",
  AAPL: "#60a5fa",
};

function getColor(ticker) {
  return TICKER_COLORS[ticker] || "#818cf8";
}

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const d = payload[0].payload;
    return (
      <div style={{
        backgroundColor: "#1a1a1a",
        border: "1px solid #3a3a3a",
        borderRadius: "8px",
        padding: "10px 14px",
        fontSize: "13px",
      }}>
        <p style={{ margin: 0, fontWeight: 700, color: "#fff" }}>{d.name}</p>
        <p style={{ margin: "4px 0 0", color: "#ccc" }}>
          Allocation: {(d.value * 100).toFixed(2)}%
        </p>
      </div>
    );
  }
  return null;
};

export default function PieChartComponent({ pieData }) {
  if (!pieData || Object.keys(pieData).length === 0) return null;

  const data = Object.entries(pieData)
    .map(([id, { Weight, Ticker }]) => ({
      id,
      name: Ticker,
      value: Math.abs(Weight),
    }))
    .sort((a, b) => b.value - a.value);

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={{ width: "220px", height: "220px", flexShrink: 0 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              outerRadius={100}
              innerRadius={35}
              dataKey="value"
              startAngle={90}
              endAngle={-270}
              isAnimationActive={true}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={getColor(entry.name)} stroke="#242424" strokeWidth={2} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "10px", paddingLeft: "20px", flexShrink: 0 }}>
        {data.map((entry, index) => (
          <div key={entry.name} style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px", color: "white" }}>
            <span style={{ width: "10px", height: "10px", borderRadius: "50%", backgroundColor: getColor(entry.name), flexShrink: 0 }} />
            {entry.name}
          </div>
        ))}
      </div>
    </div>
  );
}
